import './Footer.css';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../res/only_writing.webp';

const Footer = () => {
    const { t } = useTranslation();

    const location = useLocation();
    const handleLogoClick = () => {
        if (location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <footer className='footer'>
            <div className="footer-content">
                <div className="footer-left">
                    <Link to="/" onClick={handleLogoClick}>
                        <img className="footer-logo" src={logo} alt="Umi Sushi" />
                    </Link>
                </div>

                <div className="footer-right">
                    <Link
                        to="/privacy"
                        className="footer-link"
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                    >
                        {t('privacy-policy')}
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer